import { render } from "./Employee.vue?vue&type=template&id=2a60c200&scoped=true"
import script from "./Employee.vue?vue&type=script&lang=js"
export * from "./Employee.vue?vue&type=script&lang=js"

import "./Employee.vue?vue&type=style&index=0&id=2a60c200&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-2a60c200"

export default script